import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Banner = ({ content }) => {
    return (
        <Chip id="260454" type="struct" title="头图" groupName="banner">
            <div
                className={styles.banner}
                style={{
                    backgroundImage: `url(${content.banner})`,
                }}
            />
        </Chip>
    );
};

Banner.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Banner);
